export const files = {
  read: 'local-file-content-received',
  get: 'file-content-received',
  create: 'new-file-created',
  replace: 'file-content-updated',
  remove: 'file-deleted'
}
